import parseISO from 'date-fns/parseISO'
import formatDate from "@utils/format-date";

export function levelDateRange(startedAt = '', expiredAt = '' ) {
  const formatStartDate = startedAt
    ? formatDate(parseISO(startedAt), 'yyyy/MM/dd')
    : '即日起';
  const formatEndDate = expiredAt
    ? formatDate(parseISO(expiredAt), 'yyyy/MM/dd')
    : '不限時間';

  return expiredAt && expiredAt
    ? [
      formatStartDate,
      formatEndDate
    ].join('-')
    : '無期限'
}

export function currentMmberDiscount(level, orderType = 'default') {
    const map = () =>  {
      return {
        reservation: level?.discount?.cosmetic ?? 0,
        prepaid: level?.discount?.prepaid ?? 0,
        deposit: level?.discount?.deposit ?? 0,
        homestay: level?.discount?.homestay ?? 0,
        daycare: level?.discount?.daycare ?? 0,
        default: 0
      }
    }
    return map()[orderType] ?? 0
}

export function memberLevelPriceDiscount(price, { levelDiscount, levelDiscountType }) {
    switch(levelDiscountType) {
      case 'fixed':
        return price - levelDiscount < 0 ? 0 : price - levelDiscount
      case '%':
        return price - Math.round((price) * (levelDiscount / 100));
      default:
        return price
    }
}